import React__default from 'react';
import { I as InlineTouchLinkButton, a as InlineTouchLinkAnchor } from '../TouchLink.styles-B0xg8y_v.js';
import { T as TouchLinkBody } from '../TouchLinkBody-yzGPWPL0.js';

const InlineTouchLink = ({
  children,
  href,
  onClick
}) => {
  if (onClick) {
    return /*#__PURE__*/React__default.createElement(InlineTouchLinkButton, {
      onClick: onClick
    }, /*#__PURE__*/React__default.createElement(TouchLinkBody, null, children));
  }
  return /*#__PURE__*/React__default.createElement(InlineTouchLinkAnchor, {
    href: href
  }, /*#__PURE__*/React__default.createElement(TouchLinkBody, null, children));
};

export { InlineTouchLink as I };
//# sourceMappingURL=InlineTouchLink-36fRCmKf.js.map
